import { render, staticRenderFns } from "./PastQuarters.vue?vue&type=template&id=831ff42a&scoped=true"
import script from "./PastQuarters.vue?vue&type=script&lang=js"
export * from "./PastQuarters.vue?vue&type=script&lang=js"
import style0 from "./PastQuarters.vue?vue&type=style&index=0&id=831ff42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831ff42a",
  null
  
)

export default component.exports